import { render, staticRenderFns } from "./TeachersOthers.vue?vue&type=template&id=b6b8b91a&scoped=true&"
import script from "./TeachersOthers.vue?vue&type=script&lang=js&"
export * from "./TeachersOthers.vue?vue&type=script&lang=js&"
import style0 from "./TeachersOthers.vue?vue&type=style&index=0&id=b6b8b91a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b8b91a",
  null
  
)

export default component.exports